import React from "react";
import { GenericSignal, SignalType } from "@types";
import { Avatar, AvatarSize } from "@taskpane/components";
import css from "./NewTeamMemberSignalContent.module.scss";

export interface NewTeamMemberSignalContentProps {
  signal: GenericSignal<SignalType.NewTeamMember>;
}

const NewTeamMemberSignalContent: React.FC<NewTeamMemberSignalContentProps> = ({ signal }) => {
  const { newUser } = signal.eventMetadata || {};
  const [newUserFirstName, newUserLastName] = newUser?.name?.split(" ") || [];
  const newUserName = newUserLastName
    ? `${newUserFirstName} ${newUserLastName[0]}.`
    : newUser?.email || "User";

  const attrs = {
    container: {
      className: css.container,
    },
    textWrapper: {
      className: css.textWrapper,
    },
    title: {
      className: css.title,
    },
    description: {
      className: css.description,
    },
    content: {
      className: css.content,
    },
    avatarWrapper: {
      className: css.avatarWrapper,
    },
    avatar: {
      size: AvatarSize.XL,
      name: newUser?.name || newUser?.email || "User",
      src: newUser?.avatar,
      className: css.avatar,
    },
    label: {
      className: css.label,
    },
  };

  return (
    <div {...attrs.container}>
      <div {...attrs.textWrapper}>
        <span {...attrs.title}>Your team is growing</span>
        {/* <span {...attrs.description}>There are 8 users in your team now!</span> */}
      </div>
      <div {...attrs.content}>
        <div {...attrs.avatarWrapper}>
          <Avatar {...attrs.avatar} />
          <span {...attrs.label}>+ {newUserName}</span>
        </div>
      </div>
    </div>
  );
};

export default NewTeamMemberSignalContent;
